module.exports = __webpack_public_path__ + "static/media/gallery-img-4.ec38d530.jpg";